import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@base/base.component';
import { Comissioned } from '@models/comissioned';

interface ComissionedAccessPoint extends Comissioned {
  parent: boolean;
}

@Component({
  selector: 'app-access-point',
  templateUrl: './access-point.component.html',
  styleUrl: './access-point.component.scss'
})
export class AccessPointComponent extends BaseComponent implements OnInit {
  public comissioners: ComissionedAccessPoint[] = []
  public accessPoint: Comissioned = this.getAccessPoint();

  constructor(){
    super()


  }

  ngOnInit(): void {
    const userComissioners = this.getUser().comissioners;

    this.comissioners = userComissioners.flatMap((comissioner) => [
      {
        ...comissioner,
        parent: true,
      },

      ...(comissioner.comissioners ?? []).map((subComissioner) => ({
        ...subComissioner,
        parent: false,
      })),
    ]);

    this.accessPoint.identifierCode = this.comissioners.find(comissioner => comissioner.id === this.accessPoint.id && comissioner.isEconomicGroup === this.accessPoint.isEconomicGroup).identifierCode

  }

  public getPrefix(comissionedAccessPoint: Comissioned): string {

    if(!comissionedAccessPoint){
      return ""
    }

    return comissionedAccessPoint?.comissioners?.length > 0 ? "GE" : "PV"
  }

  public onClickAcessPoint(comissionedAccessPoint: ComissionedAccessPoint): void {
    this.setAccessPoint(comissionedAccessPoint)
    this.accessPoint = this.getAccessPoint();
    window.location.reload(); // Força a atualização da página

  }
}
